<div class="button-wrapper">
    <button class="ripple" [disabled]="loading() || disabled()" (click)="onButtonClick()" type="button" [class.secondary-btn-style]="isSecondaryBtnStyle()">
        @if (!loading()) {
        <ng-content></ng-content>
        } @else {
        <webstore-spinner></webstore-spinner>
        }
    </button>
</div>